import Form from './components/Form.vue';
import Login from './components/Login.vue';
import ShowProject from './components/ShowProject.vue';
import MyTask from './components/MyTask.vue';
import ViewSubscription from './components/subscription/ViewSubscription.vue';
import AddClient2 from './components/AddClient2.vue';
import ViewClient from './components/ViewClient.vue';

export const routes = [
    {
        path: '/home',
        component: Form,
        meta: { requiresAuth: true },
        props: route => ({ query: route.query.filtername })
    },
    {
        path: '/',
        name: 'login',
        component: Login,
        meta: { guestOnly: true }
    },
    { path: '/dist', redirect: { name: 'login' } },
    {
        path: '/project/:projectId',
        name: 'showproject',
        component: ShowProject,
        meta: { requiresAuth: true }
    },
    {
        path: '/mytask',
        name: 'mytask',
        component: MyTask,
        meta: { requiresAuth: true }
    },
    {
        path: '/subscriptions',
        name: 'subscriptions',
        component: ViewSubscription,
        meta: { requiresAuth: true }
    },
    {
        path: '/client',
        name: 'addclient',
        component: AddClient2,
        meta: { requiresAuth: true }
    },
    {
        path: '/clients',
        name: 'viewclient',
        component: ViewClient,
        meta: { requiresAuth: true }
    }
];

